import type { ButtonProps } from '@mui/material';
import MuIButton from '@mui/material/Button';
import { forwardRef } from 'react';

interface ExtendedButtonProps extends ButtonProps {
  to?: string;
}

const Button = forwardRef<HTMLButtonElement, ExtendedButtonProps>((props, ref) => {
  return <MuIButton ref={ref} {...props} />;
});
Button.displayName = 'Button';
export default Button;
